import { types } from './constants';

export const INITIAL_STATE = {
  epgData: {
    errors: null,
    isLoading: false,
    items: []
  },
  epgIds: [],
  swiperSlideLength: 0,
  swiperSlidesPerView: 0,
  swiperContainerPercentageWidth: 0,
  swiperVirtualSizePxWidth: 0,
  timeListInDay: [],
  currentTime: {
    date: null,
    swiperPxWidthOnAllSlides: null
  },
  broadcastLive: true,
  selectedDay: null,
  selectedEpgId: null,
  selectedProgramItem: null,
  inputSearch: ''
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.EPG_DATA_FETCH:
      return {
        ...state,
        epgData: {
          ...state.epgData,
          errors: null,
          isLoading: true
        }
      };
    case types.EPG_DATA_FETCH_FAILURE:
      return {
        ...state,
        epgData: {
          errors: action.errors,
          isLoading: false,
          items: []
        }
      };
    case types.EPG_DATA_FETCH_SUCCESS:
      return {
        ...state,
        epgData: {
          errors: null,
          isLoading: false,
          items: action.epgDataItems
        }
      };
      case types.EPG_DATA_ID:
        return {
          ...state,
          epgIds: action.dataIds
        };
    case types.EPG_INPUT_SEARCH:
      return {
        ...state,
        inputSearch: action.inputSearch
      };
    case types.SELECTED_DAY_CHANGED:
      return {
        ...state,
        selectedDay: action.selectedDay
      };
    case types.EPG_SWIPER_VIRTUAL_SIZE_PX_WIDTH:
      return {
        ...state,
        swiperVirtualSizePxWidth: action.swiperVirtualSizePxWidth
      };
    case types.EPG_SWIPER_SLIDE_LENGTH:
      return {
        ...state,
        swiperSlideLength: action.swiperSlideLength
      };
    case types.EPG_SWIPER_SLIDE_PER_VIEW:
      return {
        ...state,
        swiperSlidesPerView: action.swiperSlidesPerView
      };
    case types.EPG_TIME_LIST_IN_DAY:
      return {
        ...state,
        timeListInDay: action.timeListInDay
      };
    case types.EPG_CURRENT_TIME:
      return {
        ...state,
        currentTime: action.currentTime
      };
    case types.SELECTED_PROGRAM_ITEM:
      return {
        ...state,
        selectedEpgId: action.selectedEpgId,
        selectedProgramItem: action.selectedProgramItem
      };
    case types.DESELECTED_PROGRAM_ITEM:
      return {
        ...state,
        selectedEpgId: null,
        selectedProgramItem: null
      };
    case types.EPG_BRODCAST_LIVE:
      return {
        ...state,
        broadcastLive: action.broadcastLive
      };
    default:
      return state;
  }
};

export default reducer;
